import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';

interface RejectedDomainsChartProps {
  data: Array<{ domain: string; count: number }>;
}

export function RejectedDomainsChart({ data }: RejectedDomainsChartProps) {
  const displayData = data.slice(0, 15).map(d => ({
    ...d,
    shortDomain: d.domain.length > 25 ? d.domain.substring(0, 22) + '...' : d.domain,
  }));

  return (
    <Card>
      <CardHeader>
        <CardTitle>Mest avviste domener (topp 15)</CardTitle>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={400}>
          <BarChart data={displayData} layout="vertical">
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis type="number" />
            <YAxis dataKey="shortDomain" type="category" width={150} />
            <Tooltip 
              formatter={(value: number) => [`${value} ganger`, 'Avvist']}
              labelFormatter={(label: string) => {
                const item = data.find(d => d.domain.startsWith(label.replace('...', '')));
                return item?.domain || label;
              }}
            />
            <Bar dataKey="count" fill="hsl(var(--destructive))" />
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}
